import React from 'react';
import { Form, Modal, Segment,Button, } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../../_utils/config';
import swal from "sweetalert";

export default class ModalEdit extends React.Component {
   
   constructor(props){
      super(props);
      this.state = {
         data:{
            id:props.data_edit.id,
            public_id:props.data_edit.public_id,
            nama:props.data_edit.nama,
            kode:props.data_edit.kode,
            jabatan:props.data_edit.jabatan,
            alamat:props.data_edit.alamat,
            contact:props.data_edit.contact,
         },
         
         request:true,
         loading:false,
         error:false
      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      
   }

   onSubmit(e){
      const {nama, kode, jabatan, alamat} = this.state.data;
      e.preventDefault();
      this.setState({loading:true});
      e.preventDefault();
      if(kode===null || kode===""){
         this.setState({loading: false, error: true});
         swal("", "NIP/Kode Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(nama===null || nama===""){
         this.setState({loading: false, error: true});
         swal("", "Nama Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(alamat===null || alamat===""){
         this.setState({loading: false, error: true});
         swal("", "Alamat Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(jabatan===null || jabatan===""){
         this.setState({loading: false, error: true});
         swal("", "Jabatan Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else{
         this.setState({loading:true});
         fetch(`${BaseURLDev}/user/verificator/${this.state.data.public_id}`,{
            method: 'PUT',
            body: JSON.stringify(this.state.data),
            headers
         })
         .then(response => {
            if (!response.ok) { 
               swal("", "Update data user OPD gagal", "error");
               this.setState({loading:false,error:true});
               return Promise.reject(response.statusText);
            }
            else{
               swal("", "Update data user OPD selesai", "success");

               this.setState({loading:false});               
            }
         })
         .catch(err =>{
            swal("", "Silahkan check koneksi internet Anda\n atau sedang terjadi gangguan di server", "error");
            this.setState({requests:false})
            return false;
         })
      }
   }

   onChange = (e) => this.setState({data:{...this.state.data, [e.target.name]:e.target.value}})      

   render() {

      const {nama,kode,jabatan,alamat,contact} = this.state.data;
      const {loading,error} = this.state;
      
      return (
      <div>
         <Modal trigger={<Button>Show Modal</Button>}
            open={this.props.open}
            onClose={this.props.onClose}
            closeOnEscape={false}
            closeOnRootNodeClick={false}
            size="small"
         >
            <Modal.Header>
               Edit user OPD username : {this.props.data_edit.user.username}
            </Modal.Header>
            
            <Modal.Content>
               <Segment>
                  <Form onSubmit={this.onSubmit} loading={loading}>
                     <Form.Input autoFocus error={kode===""?error:false} value={kode} title="NIP/Kode Pegawai" onChange={this.onChange} name="kode" placeholder="NIP/Kode Pegawai"/>
                     <Form.Input error={nama===""?error:false} value={nama} onChange={this.onChange} name="nama" placeholder='Nama pegawai' title="Nama pegawai" />               
                     <Form.Input value={jabatan} onChange={this.onChange} name="jabatan" placeholder='Jabatan pegawai' title="Jabatan pegawai" />               
                     <Form.Input value={contact} onChange={this.onChange} name="contact" placeholder='Nomor contact' title="Nomor contact"/>               
                     <Form.TextArea value={alamat} onChange={this.onChange} placeholder='Alamat pegawai' name="alamat" title="Alamat pegawai" />
                     <Form.Button positive>Perbaharui</Form.Button>
                  </Form>
               </Segment>
            </Modal.Content>
            <Modal.Actions>
               <Button negative onClick={this.props.onClose}>Tutup</Button>                        
            </Modal.Actions>
         </Modal>
      </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_user/_userverificator/ModalEdit.js